import React from "react";
import { Pencil, Trash2, ImagePlus } from "lucide-react";
import { formatPrice } from "../../mock";
import { imgSrc } from "./imageUtils";

const statusOf = (p) => {
  if (p.inStock) return { label: "Auf Lager", cls: "bg-[#3f8f2a]" };
  if (p.active) return { label: "Ausverkauft", cls: "bg-slate-500" };
  return { label: "Deaktiviert", cls: "bg-slate-400" };
};

const ProductRow = ({ p, onEdit, onDelete }) => {
  const status = statusOf(p);
  return (
    <div data-testid={`product-row-${p.id}`} className="rounded-2xl border border-slate-100 bg-white/60 p-4 flex flex-wrap items-center gap-4">
      {p.image ? (
        <img src={imgSrc(p.image)} alt={p.name} className={`h-16 w-16 rounded-xl object-cover border border-slate-100 ${p.inStock ? "" : "grayscale opacity-60"}`} />
      ) : (
        <div className="h-16 w-16 rounded-xl bg-slate-50 border border-slate-100 flex items-center justify-center text-slate-300">
          <ImagePlus className="h-6 w-6" />
        </div>
      )}
      <div className="flex-1 min-w-[180px]">
        <p className="font-bold text-slate-800">
          {p.name} {p.variant && <span className="text-slate-400 font-semibold">– {p.variant}</span>}
        </p>
        <p className="text-sm text-slate-500">
          {p.category} · <span className="font-bold text-[#f7941e]">{formatPrice(p.price)}</span>
          {" · "}<span data-testid={`product-qty-${p.id}`}>{p.stock} Stk.</span>
          {p.images?.length > 1 && ` · ${p.images.length} Bilder`}
        </p>
      </div>
      <span className={`rounded-full px-3 py-1 text-xs font-extrabold text-white ${status.cls}`} data-testid={`product-stock-${p.id}`}>
        {status.label}
      </span>
      <div className="flex gap-2">
        <button onClick={() => onEdit(p)} data-testid={`product-edit-${p.id}`} title="Bearbeiten"
          className="h-10 w-10 rounded-full border border-sky-200 text-[#1273a8] flex items-center justify-center hover:bg-sky-50 transition-colors">
          <Pencil className="h-4 w-4" />
        </button>
        <button onClick={() => onDelete(p)} data-testid={`product-delete-${p.id}`} title="Löschen"
          className="h-10 w-10 rounded-full border border-red-200 text-red-500 flex items-center justify-center hover:bg-red-50 transition-colors">
          <Trash2 className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default ProductRow;
